const $menu = {
  state: {
    name: '/censusBusiness',
    list: [],
    cardModel: 'mall'
  },
  mutations: {
    GET_NAME: (state, data) => {
      state.name = data;
    },
    GET_LIST: (state, data) => {
      state.list = data;
    },
    SET_CARD_MODEL: (state, data) => {
      state.cardModel = data;
    }
  },
  actions: {
    GetName ({commit}, data) {
      commit('GET_NAME', data);
    },
    GetList ({commit}, data) {
      commit('GET_LIST', data);
    }
  }
};

export default $menu;



// WEBPACK FOOTER //
// ./src/store/modules/menu.js